import actions from './actions';

const {
  GET_REFERRAL_BEGIN, GET_REFERRAL_SUCCESS, GET_REFERRAL_FAILED,
  ADD_REFERRAL_BEGIN, ADD_REFERRAL_SUCCESS, ADD_REFERRAL_FAILED,
  UPDATE_REFERRAL_BEGIN, UPDATE_REFERRAL_SUCCESS, UPDATE_REFERRAL_FAILED,
  DELETE_REFERRAL_BEGIN, DELETE_REFERRAL_SUCCESS, DELETE_REFERRAL_FAILED
} = actions;

const initState = {
  total: 0,
  currentPage: 1,
  pageLimit: 50,
  referrals: [],
  loading: false,
  error: null,
};


const ReferralReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_REFERRAL_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_REFERRAL_SUCCESS:
      return {
        ...state,
        total: data.total || 0,
        referrals: data.referral,
        currentPage: data.currentPage || state.currentPage,
        pageLimit: data.pageLimit || state.pageLimit,
        loading: data.pageLimit ? false : true,
      };
    case GET_REFERRAL_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case ADD_REFERRAL_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case ADD_REFERRAL_SUCCESS:
      return {
        ...state,
        total: state.total + 1,
        referrals: data,
        loading: false,
      };
    case ADD_REFERRAL_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case UPDATE_REFERRAL_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_REFERRAL_SUCCESS:
      return {
        ...state,
        referrals: data,
        loading: false,
      };
    case UPDATE_REFERRAL_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case DELETE_REFERRAL_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_REFERRAL_SUCCESS:
      return {
        ...state,
        total: state.total - 1,
        referrals: data,
        loading: false,
      };
    case DELETE_REFERRAL_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default ReferralReducer;